/*
 * @FilePath: /mall-fe/src/pages/index.tsx
 * @Description: 商城首页门户网页入口 获取服务端数据
 *
 */
import { getFloor, getFloorV2 } from 'api/std';
import {
  getBanner,
  getSkuStatisticsInfo,
  searchBulletin,
  apiGetProjectNewAddList,
  apiGetFactoryDirectList,
} from 'api/user';
import { CategoryContext, MediaQueryContext } from 'libs/contexts';
import { BANNER_TYPE_ENUM, FloorType } from 'libs/enums';
import { allSettled, isMobileMall, strToObj } from 'libs/utils';
import { GetServerSideProps } from 'next';
import { useContext } from 'react';
import IndexMobile from 'views/h5/Home/index';
import IndexPc from 'views/web/home/index';

const PageIndex = (props: any) => {
  const { isMobile } = useContext(MediaQueryContext);
  const categorys = useContext(CategoryContext);
  const pcProps = {
    ...props,
    categorys: categorys,
  };
  return isMobile ? <IndexMobile {...props} /> : <IndexPc {...pcProps} />;
};
export default PageIndex;
export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const serverHeaders = ctx.req.headers;
  const tenantCode = ctx.req?._tenantCode;
  const AREA_CODE_KEY = `${tenantCode}_area_code`; // 租户所在地区存取key
  const cookie = strToObj(serverHeaders.cookie);
  const areaCode = cookie[AREA_CODE_KEY] ?? '0';

  // 微信环境 - 修复：确保 user-agent 存在再调用 includes
  const userAgent = serverHeaders['user-agent'] || '';
  const isOffcialAccount = userAgent.includes('MicroMessenger');
  const isMniprogramEnv = userAgent.includes('miniProgram');
  const isQywx = userAgent.includes('wxwork');

  const getIndexFloor = getFloorV2;

  if (!isMobileMall(ctx?.req)) {
    const apiList = [
      getBanner(BANNER_TYPE_ENUM.ZJ3_MALL_INDEX, {
        serverSide: true,
        headers: serverHeaders,
      }),
      searchBulletin({
        serverSide: true,
        headers: serverHeaders,
        json: {
          pageNo: 1,
          pageSize: 15, // 和【当前注册/准入动态】的后台限制个数保持一致
          dynamicPublishFlag: true, // 是否发布到平台动态
        },
      }),
      getSkuStatisticsInfo(areaCode, {
        serverSide: true,
        headers: serverHeaders,
      }),
      getIndexFloor(FloorType.ZJ3_RECOMMEND_SHOP, {
        serverSide: true,
        headers: serverHeaders,
      }),
      getIndexFloor(FloorType.ZJ3_HOT_SALE_SKU, {
        serverSide: true,
        headers: serverHeaders,
      }),
      getIndexFloor(FloorType.Index, {
        serverSide: true,
        headers: serverHeaders,
      }),
      getFloor(FloorType.IndexBrands, {
        serverSide: true,
        headers: serverHeaders,
      }),
      getBanner(BANNER_TYPE_ENUM.ZJ3_HIRE_BANNER, {
        serverSide: true,
        headers: serverHeaders,
      }),
      apiGetProjectNewAddList({
        serverSide: true,
        headers: serverHeaders,
        json: {
          pageNo: 1,
          pageSize: 4,
          homeFlag: true,
        },
      }),
      apiGetFactoryDirectList({
        serverSide: true,
        headers: serverHeaders,
        json: {
          published: true,
        },
      }),
    ];
    const allData = await allSettled(apiList);
    const [
      bannerRes,
      bulletinRes,
      skuStatisticsRes,
      recommendRes,
      hotRes,
      floorsRes,
      brandsRes,
      hireBannerRes,
      // newIndexRecommendRes,
      // newIndexHotRes,
      // newIndexFloorsRes,
      // newIndexBannerRes,
      // newIndexBulletinRes,
      // outwardHireBannerRes,
      projectNewAddListRes,
      factoryDirectListRes,
    ] = allData;
    const bannersData = bannerRes?.data?.data || [];
    const bulletinData = bulletinRes?.data?.data?.datas || [];
    const skuStatisticsData = skuStatisticsRes?.data?.data || {};
    const recommendData = recommendRes?.data?.data || [];
    const hotData = hotRes?.data?.data || [];
    const floorsData = floorsRes?.data?.data || [];
    const brandsData = brandsRes?.data?.data || [];
    // const newIndexRecommendData = newIndexRecommendRes?.data?.data || [];
    // const newIndexHotData = newIndexHotRes?.data?.data || [];
    const hireBannerData = hireBannerRes?.data?.data || [];
    // const newIndexFloorsData = newIndexFloorsRes?.data?.data || [];
    // const newIndexBannerData = newIndexBannerRes?.data?.data || [];
    // const newIndexBulletinData = newIndexBulletinRes?.data?.data?.datas || [];
    // const outwardHireBannerData = outwardHireBannerRes?.data?.data || [];
    const projectNewAddListData = projectNewAddListRes?.data?.data || {};
    const factoryDirectListData = factoryDirectListRes?.data?.data || [];
    return {
      props: {
        bannersData,
        bulletinData,
        skuStatisticsData,
        recommendData,
        hotData,
        floorsData,
        brandsData,
        // newIndexRecommendData,
        // newIndexHotData,
        hireBannerData,
        // newIndexFloorsData,
        // newIndexBannerData,
        // newIndexBulletinData,
        // outwardHireBannerData,
        projectNewAddListData,
        factoryDirectListData,
      },
    };
  } else {
    return {
      props: {
        isQywx,
        isOffcialAccount,
        isMniprogramEnv,
      },
    };
  }
};
